/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IntegrationEntry,
  IntegrationEntry$inboundSchema,
} from "./integrationentry.js";

export type ListIntegrationsResult = {
  /**
   * List of available third-party integrations
   */
  integrations?: Array<IntegrationEntry> | undefined;
};

/** @internal */
export const ListIntegrationsResult$inboundSchema: z.ZodMiniType<
  ListIntegrationsResult,
  unknown
> = z.object({
  integrations: z.optional(z.array(IntegrationEntry$inboundSchema)),
});

export function listIntegrationsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListIntegrationsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIntegrationsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIntegrationsResult' from JSON`,
  );
}
